import styled from 'styled-components';
import { ReactComponent as Logo } from 'assets/images/Sunbelt.svg';

export const StyledAuthorisingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const StyledLogoContainer = styled.div`
    padding: 25px 0;
`;

export const StyledLogo = styled(Logo)`
    width: 150px;
    max-width: 150px;
    animation: spin 3s linear infinite;
`;

export const StyledTextContainer = styled.div`
    padding: 25px 0;
`;

export const StyledText = styled.h1`
    display: block;
    font-size: 2em;
`;
